import React, { useState, useEffect, useContext } from 'react'
import { Spacer, Container, Row, Col, Truncate, Radio, Toast, Button, Checkbox, Divider } from '@cleartrip/bento'
import ErrorBoundary from 'components/ErrorBoundary'
import GlobalNav from 'components/GlobalNav/homepage'
import HomePageFaq from 'components/HomePageFaq'
import Footer from 'components/Footer'
import langTranslate from 'locale'
import data from 'components/ModifySearch/data'
import CalendarWrapper from 'components/CalendarWrapper/HomeCalendarNew'
import HomeOffer from 'components/homeOffer'
import CarousalOffer from 'components/homeOffer/carousal'
import ImageGrid from 'components/ImageGrid'
import Humbger from 'components/HumbergerNew'
// import LanguageSelect from 'components/LanguageSelect'
import CookieBanner from 'components/CookieBanner'
import { useHistory } from 'react-router'
import { airportSuggestConverter } from 'utils/flights/results'
import { getInitialDataLayerParams } from 'utils/dataLayerHelper'
import { isFeatureEnabled } from 'utils/uiHelper'
import USER_PROFILE_PAGE_CONTANTS from 'components/GlobalNav/UserProfile/UserProfileConstants.js'
import { triggerHiFiveClevertap } from 'components/HiFivePageModal/hiFiveClevertap'
import ViewContainer from 'components/GlobalNav/UserProfile/ViewContainer.js'
import './_home.scss'
import { resolveKeysInObjectsArrays } from 'utils/browserHelper'
import { ProfileDataContext } from 'context/flights/results'
import {
    isEmpty,
    getCookie,
    appPrefix,
    debounce,
    replaceQueryInUrl,
    formSrpUrl,
    ONWARD_DIR_ARROW,
    setCookie,
    getUserAuthValues,
    isUserSignedIn
} from 'utils/browserHelper'
import {
    airportSearch,
    getFlightOffer,
    airLineSearch,
    getAbTestConfig,
    getUserProfileDetails,
    getCompliancePolicyStatus
} from 'api/flights/results'

import { getFormattedDate, dateDiff , dayDiff } from 'utils/dateHelper'
import { ReactComponent as RightArr } from 'assets/icons/rightarr.svg'
import { getflightsHistory, updateHomeSearch } from 'components/ModifySearch/recentSearch'
import { DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
import { DOMAIN, HI_FIVE_URL, defaultAbValues } from 'constants/base'
import { paidChannelTracker, paidAffiliateTracker, isFlightsPage } from 'utils/utmHelper'
import { homePageLoad } from 'analytics/logPageLoadEvents'
import Clevertap from 'analytics'
import TripSuggestor from 'components/TripSuggestor'
import useModal from 'lib/Modal/useModal'
import NewAirportField from 'components/NewAirportField'
import JourneyDropdown from 'components/JourneyDropdown'
import TravellerAndClass from 'components/TravellerAndClass'
import { FARE_TYPE, returnFareName } from 'constants/fareType'
import PopularSearch from './popularSearch'
import SplFareType from 'components/SplFareType'
import SpecialFareModal from 'components/SplFareType/SpecialFareModal'
import { dataLayerGA, GaDataPush } from 'utils/dataLayerHelper.js'
import { htmlSanitizer } from 'utils/browserHelper'
import { flightsFaq, ctFlightsFeatures, ctFeatures, cleartripHomeFaq } from 'constants/homeFaqs'
import {ReactComponent as TickMark} from 'assets/icons/check_circle.svg'
import { Helmet } from 'react-helmet'
import { func } from 'prop-types'
import FeatureWidget from 'components/FeatureWidget'
import FeatureWidgetModal from 'components/FeatureWidgetModal'
import { ravenSDKTrigger } from 'utils/ravenSDKhelper'
import { fetchFccAds } from 'api/flights/monetization'
import FkImages from '../FkImages'
import RavenWebManager from 'components/RavenWebSDK'
import ComplianceBanner from 'components/ComplianceBanner'
function Home(props) {
    const { hasError = false, initialTS = new Date().getTime(), resetInitialTime = () => {} } = props || {}
    const isRtl = process.env.CONTENT_DIR === 'RTL'
    const { isShowing, toggle } = useModal()
    const { isShowing:splFareIsShowing, toggle:splFareToggle } = useModal()
    const [userProfile, setUserProfile] = useContext(ProfileDataContext)
    const [isDepartureDropdown, setIsDepartureDropdown] = useState(true)
    const [isArrivalDropdown, setIsArrivalDropdown] = useState(true)
    const [isAirLineListDropdown, setIsAirLineDropdown] = useState(true)
    const [clickedItem, setClickedItem] = useState(false)
    const [airportSearchList, setAirportList] = useState({ departure: data.popular, arrival: data.popular })
    const [flightsSearchList, setFlightsSearchList] = useState(getflightsHistory())
    const [swap, setSwap] = useState(false)
    const [toast, setToast] = useState({})
    const [showFeatureWidgetModal, setShowFeatureWidgetModal] = useState(false)
    const [isShowFeatureWidget, setShowFeatureWidget] = useState(false)
    const [cookieBannerFlag, setCookieBanner] = useState(
        window && window.localStorage && !window.localStorage.getItem('gdpr')
    )
    const [fareList, setFareList] = useState(FARE_TYPE)

    const [finalDeparture, setFinalDeparture] = useState('')
    const [finalArrival, setFinalArrival] = useState('')
    const [showLoginSuccess, setShowLoginSuccess] = useState(false)
    const [showSignupSuccess, setShowSignupSuccess] = useState(false)
    const [multiCityDestinations, setMultiCityDestinations] = useState({
        from1: '',
        from2: '',
        from3: '',
        to1: '',
        to2: '',
        to3: '',
        depart_date_1: '',
        depart_date_2: '',
        depart_date_3: '',
        from1City: '',
        from2City: '',
        from3City: '',
        from1Code: '',
        from2Code: '',
        from3Code: '',
        to1City: '',
        to2City: '',
        to3City: '',
        to1Code: '',
        to2Code: '',
        to3Code: '',
        adults: 1,
        childs: 0,
        infants: 0,
        intl: 'n',
        thirdJourneyDisable: true,
        from1Error: false,
        from2Error: false,
        from3Error: false,
        to1Error: false,
        to2Error: false,
        to3Error: false,
        depart_date_1Error: false,
        depart_date_2Error: false,
        depart_date_3Error: false
    })
    let [departure, setDeparture] = useState('')
    let [arrival, setArrival] = useState('')
    

    const [city, setCity] = useState({
        source: '',
        destination: '',
        sourceCountry: '',
        destinationCountry: '',
        sCode: '',
        dCode: '',
        isIntl: '',
        departureError: false,
        arrivalError: false
    })
    const [activeFare, setActiveFare] = useState('rf')
    const [loading, setloading] = useState(false)
    let [getAdults, setAdults] = useState(1)
    const [getOffer, setFlightOffer] = useState({})
    const [getAbTest, setAbTest] = useState({
        e_home: 'z', ctUpgrade: 'c',
        ...defaultAbValues
    })
    const [airlineShowFlag, setairlineShowFlag] = useState(false)
    const [toggleCredit, toggleCreditShell] = useState(getCookie('cShell'))
    const [tripType, setTripSelect] = useState('O')
    const [query, setQuery] = useState({ adults: 1, childs: 0, infants: 0, class: 'Economy' })
    const browserHistory = useHistory()
    const [airline, setAirlineQuery] = useState('')
    const [preferdAirlineList, setPreferedAirline] = useState([])
    let signedIn = false
    const usermisc = getCookie('usermisc') || ''
    const { userId = '' } = getUserAuthValues()
    if (usermisc.includes('SIGNED_IN') && !isEmpty(userId)) {
        signedIn = true
    }
    const [page, setPage] = useState(null)
    const [loginRedirectUrl, setLoginRedirectUrl] = useState('')
    let flightPage = isFlightsPage()
    const countryCode = DOMAIN_COUNTRY_MAP[window.location.origin]
    const unifiedLoginFlow = DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' ? true : false

    const {
        desktopHomePageBannerNew = {},
        desktopHomePageBanner = {},
        popularDestinationEnabled = {},
        creditShellEnabled = {},
        desktopHeroOffer = {},
        carousalBanner = {},
        humbgerSale = {},
        FeatureWidgetData ={}
    } = isFeatureEnabled()
    const [fkError,setFkError] = useState({
        message:'',
        error:false
    })
    const [isFkImagesLoading,setFkImagesLoading] = useState(false)
    const [fkResponseImages,setFkResponseImages] = useState({})
    const [showComplianceBanner, setShowComplianceBanner] = useState(false)

    useEffect(() => {
        if (!isEmpty(getAbTest)) {
            setShowFeatureWidget(getAbTest.mediCancel === 'b')
        }
    }, [getAbTest])
    

    useEffect(() => {
        const asyncUseEffect = async () => {
            const abPayload = {}
            abPayload.apacheCookie = getCookie('Apache') || ''
            abPayload.userId = getCookie('userid') || ''
            const getAbTestConfigResponse = await getAbTestConfig(abPayload)

            const { data } = getAbTestConfigResponse || {}
            if (!isUserSignedIn() && unifiedLoginFlow === true) {
                if (
                    getAbTestConfigResponse?.data?.tk_home === 'b' &&
                    (resolveKeysInObjectsArrays(['location', 'pathname'], window) === '/flights' ||
                        resolveKeysInObjectsArrays(['location', 'pathname'], window) === '/')
                ) {
                    const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))
                    if (!obj?.flightHome) {
                        toggle()
                        setPage(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)
                        window.sessionStorage.setItem(
                            'loginPopup',
                            JSON.stringify({
                                ...obj,
                                flightHome: 'true',
                                flightIternary: 'true',
                                hotelIternary: 'true',
                                hotelHome: 'true'
                            })
                        )
                    }
                }
            }
            const ravenPayLoad = {
                page_name: 'flights_home',
                a_utm_source: location?.search?.split?.('utm_source=').length >1 ? location?.search?.split?.('utm_source=')?.pop()?.split('&')?.[0] : 'organic',
                page_loadtime: new Date().getTime() - initialTS || 'N/A',
                last_page_name: location?.search?.split?.('utm_source=').length >1 ? location?.search?.split?.('utm_source=')?.pop()?.split('&')?.[0] : ''
            }
            if (data) {
                homePageLoad({ initialLoadTime: initialTS, getAbTest: data, abhome: data?.tk_home })
                ravenSDKTrigger('a_home_pageload' , ravenPayLoad)
                setAbTest({ ...getAbTest, ...data })

            } else {
                console.log('ab test status failure')
                homePageLoad({ initialLoadTime: initialTS })
                ravenSDKTrigger('a_home_pageload' , ravenPayLoad)
            }
        }
        getComplianceStatus()
        getFlightOfferCall()
        asyncUseEffect()
        paidAffiliateTracker()
        paidChannelTracker()
        if (signedIn && isEmpty(userProfile)) {
            getUserProfile()
        }
        let dataLayerValues = getInitialDataLayerParams('home')
        let dataLayerEventName = 'Home_Page'
        if (window && window.location && window.location.href && window.location.href.indexOf('/flights') > -1) {
            dataLayerValues = getInitialDataLayerParams('flights')
            dataLayerEventName = 'Flights_Home'
        }
        const { dataLayer = [] } = window || {}
        dataLayer.push({
            event: dataLayerEventName,
            ...dataLayerValues
        })
        let flightHistory = getflightsHistory()
        

        if (!isEmpty(flightHistory)) {
            if (flightHistory[0].rnd_one !== 'MC') {
                let date = getFormattedDate(new Date(), 'DD/MM/YYYY')
                let departDate = flightHistory[0].depart_date
                let returnDate = flightHistory[0].return_date
                let diff = dateDiff(date, departDate, 'DD/MM/YYYY')
                if (diff < 0) {
                    flightHistory[0].depart_date = date
                }
                if (!isEmpty(returnDate)) {
                    diff = dateDiff(date, returnDate, 'DD/MM/YYYY')
                    if (diff < 0) {
                        flightHistory[0].return_date = date
                    }
                }
                setQuery({
                    ...query,
                    ...flightHistory[0]
                })
                setTripSelect(flightHistory[0].rnd_one)
                setDeparture(flightHistory[0].origin)
                setArrival(flightHistory[0].destination)
                setFinalArrival(flightHistory[0].destination)
                setFinalDeparture(flightHistory[0].origin)
                setCity({
                    ...city,
                    ...flightHistory[0],
                    sCode: flightHistory[0].from,
                    source: flightHistory[0].sourceCountry,
                    destination: flightHistory[0].destinationCountry,
                    dCode: flightHistory[0].to
                })
                setAirlineQuery(flightHistory[0].airline)
            } else if (query.depart_date === 'Invalid Date' || isEmpty(query.depart_date)) {
                setQuery({
                    ...query,
                    depart_date: getFormattedDate(new Date(), 'DD/MM/YYYY')
                })
            }
        } else if (query.depart_date === 'Invalid Date' || isEmpty(query.depart_date)) {
            setQuery({
                ...query,
                depart_date: getFormattedDate(new Date(), 'DD/MM/YYYY')
            })
        }
        // need to handle history search of last index to set the all fields
    }, [])
    useEffect(() => {
        const gaPayload = {
            section: 'Flights',
        }
        GaDataPush('event', 'home_page_land_ga', gaPayload)
        dataLayerGA(gaPayload, 'home_page_land')
         // raven event experiment
         let ravenPayload = {
            platform: "desktop",
            login_status: isUserSignedIn() ? 'yes' : 'no',
            domain: resolveKeysInObjectsArrays(['location', 'hostname'], window),
            vertical: 'air',
            page_name: 'flights_home'
          }
          RavenWebManager.event('a_m_homepage_load', {...ravenPayload})
          Clevertap.event('wr_homepage_load', {...ravenPayload})
          dataLayerGA({...ravenPayload}, 'wr_homepage_load')
        // end of raven event experiment
    }, [])

    useEffect(() => {
        if (localStorage.getItem('LoginToastShown') === 'true') {
            setShowLoginSuccess(true)
        }
        else if (localStorage.getItem('SignupToastShown') === 'true'){
            setShowSignupSuccess(true)
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            setShowLoginSuccess(false)
        }, 5000)
        localStorage.setItem('LoginToastShown', 'false')
    }, [showLoginSuccess])

    useEffect(() => {
        setTimeout(() => {
            setShowSignupSuccess(false)
        }, 5000)
        localStorage.setItem('SignupToastShown', 'false')
    }, [showSignupSuccess])

    useEffect(()=>{  
        if(desktopHomePageBanner.enabled === true && !isEmpty(desktopHomePageBanner?.fkSlots)){
            let fkTempArray = []
            let dummyObject = {}
            desktopHomePageBanner?.fkSlots?.map((item, key) => {
                if (!isEmpty(item?.slotId)) {
                    dummyObject = {
                        banner: {
                            format: null
                        },
                        ext:{
                            slotid:item?.slotId
                        }
                    }
                    fkTempArray.push(dummyObject)
                }
            })  
             fetchFkData(fkTempArray)
        }
    },[desktopHomePageBanner])

    const getComplianceStatus = async() => {
        try {
            const data = await getCompliancePolicyStatus()
            setShowComplianceBanner(!data?.isDisplayed)
        }
        catch(e) {
            console.log(e)
        }
    }
   
    const fetchFkData =async(fkTempArray)=>{
       try{
        const SitePayload = {
            id: Math.random(),
            imp: fkTempArray,
            device: {
                ua: window?.navigator?.userAgent,
                geo: {}
            },

            site: {
                id: '0',
                name: 'CA_EN',
                domain: DOMAIN
            },
            wlang: ['en']
        }
        const isAppOrSitePayload =  SitePayload //can remove
        const response = await fetchFccAds(isAppOrSitePayload)
        const { status, data, error } = response
        if(status === 200){
            setFkResponseImages(data)
        }
       }
       catch(e){
        console.log(e)
       }
    }

    async function getUserProfile() {
        try {
            const getResponse = await getUserProfileDetails()
            const { data, status } = getResponse || {}
            if (status == 200) {
                setUserProfile(data)
            }
        } catch (e) {
            console.log('User profile details api error', e)
        }
    }

    function tripTypeHandler(type) {
        setTripSelect(type)
        if (isEmpty(query.depart_date)) {
            setQuery({
                ...query,
                depart_date: getFormattedDate(new Date(), 'DD/MM/YYYY'),
                return_date: ''
            })
        }
        if (type == 'O') {
            setQuery({
                ...query,
                return_date: ''
            })
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: 'hp_radio_ow'
            })
        }
        if (type == 'R') {
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: 'hp_radio_rt'
            })
            if (isEmpty(query.return_date))
                setQuery({
                    ...query,
                    return_date: query.depart_date
                })
        }
    }

    const getFlightOfferCall = async () => {
        try {
            let lang = getCookie('lp') === 'ar' ? 'ar' : 'en'
            let countryCode = DOMAIN_COUNTRY_MAP[window.location.origin]
            if (countryCode && countryCode !== 'IN') {
                countryCode = countryCode.toLowerCase()
                const response = await getFlightOffer(countryCode)
                if (response && response.data) {
                    setFlightOffer({
                        images: response.data.images[lang]['1x'],
                        title: response.data.title,
                        url: response.data.url[lang]
                    })
                }
            } else {
                setFlightOffer({
                    images: ''
                })
            }
        } catch (e) {
            console.log('fetch offer api error', e)
        }
    }

    function changeDeparture(event) {
        let arrivalIntl = false
        if (event.target.value.length === 0) {
            setAirportList({
                ...airportSearchList,
                ['departure']: data.popular
            })
            if (!isEmpty(arrival))
                arrivalIntl = arrival.split(', ').pop().trim() !== 'IN'
            setCity({
                ...city,
                arrivalError: false,
                dCode: '',
                destination: '',
                isIntl: arrivalIntl ? 'y' : 'n'
            })
        }
        if (event.target.value.length !== 0)
            setCity({
                ...city,
                sCode: '',
                source: '',
                departureError: false
            })
        const departure = htmlSanitizer(event.target.value);
        setDeparture(departure)
        if (departure) {
            debounce(airportList, 400)(departure, 'departure')
        }
    }

    function selectDeparture(item, name) {
        let code = item.k
        let value = item.v.split(' -')[0]
        let label = code + ' - ' + value
        let isIntl =
            value
                .split(', ')
                .pop()
                .trim() !== 'IN'
        setDeparture(label)
        setFinalDeparture(label)
        setClickedItem(name)
        let source = value.split(',')[0]

        let arrivalIntl =
            arrival
                .split(', ')
                .pop()
                .trim() !== 'IN'
        if (!isEmpty(arrival) && arrivalIntl && !isIntl) {
            isIntl = true
        }
        setCity({
            ...city,
            source,
            sCode: code,
            departureError: false,
            isIntl: isIntl ? 'y' : 'n'
        })
        setToast({
            errorMsg: '',
            closeBtn: true
        })
        //updateRecentSearch(code, item.v)
    }
    function changeArrival(event) {
        let departureIntl = false
        if (event.target.value.length === 0) {
            setAirportList({
                ...airportSearchList,
                ['arrival']: data.popular
            })
            if(!isEmpty(departure))
                departureIntl = departure.split(', ').pop().trim() !== 'IN'
            setCity({
                ...city,
                arrivalError: false,
                dCode: '',
                destination: '',
                isIntl: departureIntl ? 'y' : 'n'
            })
            
        }
        if (event.target.value.length !== 0)
            setCity({
                ...city,
                arrivalError: false,
                dCode: '',
                destination: ''
            })
        const arrival = htmlSanitizer(event.target.value);
        setArrival(arrival)
        if (arrival) {
            debounce(airportList, 400)(arrival, 'arrival')
        }
    }

    function selectArrival(item, name) {
        let code = item.k
        let value = item.v.split(' -')[0]
        let label = code + ' - ' + value
        let isIntl =
            value
                .split(', ')
                .pop()
                .trim() !== 'IN'
        setArrival(label)
        setFinalArrival(label)
        setClickedItem(name)
        let destination = value.split(',')[0]

        let departureIntl =
            departure
                .split(', ')
                .pop()
                .trim() !== 'IN'
        if (!isEmpty(departure) && departureIntl && !isIntl) {
            isIntl = true
        }
        setCity({
            ...city,
            dCode: code,
            arrivalError: false,
            destination,
            isIntl: isIntl ? 'y' : 'n'
        })
        setToast({
            errorMsg: '',
            closeBtn: true
        })

        //updateRecentSearch(code, item.v)
    }
    async function airportList(string, type) {
        try {
            setloading(true)
            let searchResult = await airportSearch(string)
            if (searchResult && searchResult.status == 200 && searchResult.data) {
                if (getCookie('lp') === 'ar' && appPrefix === '/ar') {
                    searchResult.data = airportSuggestConverter(searchResult.data)
                }
                setAirportList({
                    ...airportSearchList,
                    [type]: searchResult.data
                })
                if (type === 'departure') {
                    if (searchResult.data.length === 0) {
                        setIsDepartureDropdown(false)
                    } else {
                        setIsDepartureDropdown(true)
                    }
                } else {
                    if (searchResult.data.length === 0) {
                        setIsArrivalDropdown(false)
                    } else {
                        setIsArrivalDropdown(true)
                    }
                }
                setloading(false)
            }
        } catch (e) {
            console.log('airportList api error', e)
        }
    }

    const handleIsShowing = () => {
        toggle()
    }

    function dateClick(date, range) {
        if (date.to) {
            setTripSelect('R')
            setQuery({
                ...query,
                depart_date: getFormattedDate(date.from, 'DD/MM/YYYY'),
                return_date: getFormattedDate(date.to, 'DD/MM/YYYY')
            })
        } else {
            setQuery({
                ...query,
                depart_date: getFormattedDate(date.from, 'DD/MM/YYYY')
            })
        }
    }

    function searchHandler() {
        import(/* webpackChunkName: "FlightsResults" */ "pages/flights/results")
        if (toggleCredit) {
            setCookie('cShell', 'true')
        } else {
            setCookie('cShell', '')
        }
        if (tripType !== langTranslate('MC')) {
            let queryObject = {
                ...query
            }
            queryObject.from = city.sCode
            queryObject.to = city.dCode
            queryObject.intl = city.isIntl || city.intl
            queryObject.origin = departure
            queryObject.destination = arrival
            queryObject.sft = (city.isIntl === 'y' || city.intl === 'y') ? '' : activeFare === 'rf' ? "" : activeFare
                ; (queryObject.sd = new Date().getTime()), (queryObject.rnd_one = tripType)

            let showToast = errorHandler(queryObject)
            setToast({
                errorMsg: '',
                closeBtn: false
            })

            if (showToast.validate) {
                setToast({
                    errorMsg: showToast.msg,
                    closeBtn: true
                })
            } else {
                updateHomeSearch({ ...queryObject, sourceCountry: city.source, destinationCountry: city.destination })
                replaceQueryInUrl(browserHistory, queryObject)
            }
        } else {
            modifySearchHandler()
        }
        const { from, to } = query || {}
        const { isIntl, intl } = city || {}
        Clevertap.event('Air_UI_Action', {
            action_name: 'search_flight_home_clicked',
            page_name: 'flights_home',
            action_type: 'button',
            ptc_fare: returnFareName(activeFare),
            is_ptc_fare_selected: returnFareName(activeFare) === 'Regular fare' ? 'no' : 'yes',
            dom_intl_ui_action: (isIntl || intl) === 'y' ? 'international' : 'domestic',
            journey_type_uiaction: tripType === 'O' ? 'one-way' : 'round-trip', //multicity case
            origin: city.sCode,
            destination: city.dCode,
            pax: query.adults + query.childs + query.infants
        })
        const { depart_date, return_date, adults, childs, class: travelClass } = query || {}
        const payload = {
            origin: city?.sCode,
            destination: city?.dCode,
            journey_start_date: depart_date,
            journey_return_date: tripType === 'R' ? return_date : 'N/A',
            Adult_Count: adults,
            Child_Count: childs,
            section: 'Flights',
            flight_type: (city.isIntl || city.intl) === 'y' ? 'International' : 'Domestic',
            trip_type: tripType === 'R' ? 'round' : 'single'
        }
        dataLayerGA(payload, 'flight_search_click')
        const ravenPayLoad = {
            action_name : 'search_flight_hp',
            page_name : 'flights_home',
            a_trip_type : (isIntl || intl) === 'y' ? 'international' : 'domestic',
            a_journey_type : tripType === 'O' ? 'one-way' : 'round-trip',
            a_fare_type : returnFareName(activeFare),
            a_return_date : tripType === 'R' ? return_date : 'N/A',
            a_dx : dayDiff(new Date(getFormattedDate(depart_date, 'MM/DD/YYYY', 'DD/MM/YYYY')), new Date()),
            a_adult_count : query.adults || 0,
            a_origin : city?.sCode , 
            a_child_count : query.childs || 0,
            a_infant_count : query.infants || 0,
            a_departure_date : depart_date ,
            a_destination : city?.dCode
        }
        ravenSDKTrigger('a_hp_search_click', {...ravenPayLoad})
    }
    function onClickWidget() {
        setShowFeatureWidgetModal(true)
        Clevertap.event('Air_UI_Action', {
            action_type: 'BUTTON',
            action_name: 'medicancel_modal_opened',
            platform:'DESKTOP'
        })
    }
    function closeFeatureModal() {
        setShowFeatureWidgetModal(false)
    }
    function onSearchClick(query) {
        replaceQueryInUrl(browserHistory, query)
    }
    function modifySearchHandler() {
        let showToast = {
            validate: false,
            msg: 'Departure and arrival airports / cities cannot be same.'
        }
        let {
            from1Code,
            from2Code,
            from3Code,
            to1Code,
            to2Code,
            to3Code,
            from1,
            from2,
            from3,
            to1,
            to2,
            to3,
            depart_date_1,
            depart_date_2,
            depart_date_3
        } = multiCityDestinations

        let obj = { class: query.class }
        let intl = 'n'

        let sd = new Date().getTime()
        let page = ''
        let { adults, childs, infants } = query
        if (
            isEmpty(from1Code) ||
            isEmpty(from2Code) ||
            isEmpty(to1Code) ||
            isEmpty(to2Code) ||
            isEmpty(depart_date_1) ||
            isEmpty(depart_date_2)
        ) {
            showToast.validate = true
            showToast.msg = 'Please fill the required fields.'
            setMultiCityDestinations({
                ...multiCityDestinations,
                depart_date_1Error: isEmpty(depart_date_1) ? true : false,
                depart_date_2Error: isEmpty(depart_date_2) ? true : false,
                from1Error: isEmpty(from1Code) ? true : false,
                from2Error: isEmpty(from2Code) ? true : false,
                to1Error: isEmpty(to1Code) ? true : false,
                to2Error: isEmpty(to2Code) ? true : false
            })
        } else if (!isEmpty(from3Code) || !isEmpty(to3Code) || !isEmpty(depart_date_3)) {
            if (isEmpty(from3Code) || isEmpty(to3Code) || isEmpty(depart_date_3)) {
                showToast.validate = true
                showToast.msg = 'Please fill the required fields.'
                setMultiCityDestinations({
                    ...multiCityDestinations,
                    depart_date_3Error: isEmpty(depart_date_3) ? true : false,
                    from3Error: isEmpty(from3Code) ? true : false,
                    to3Error: isEmpty(to3Code) ? true : false
                })
            } else if (from3Code == to3Code) {
                showToast.validate = true
                showToast.msg = 'Departure and arrival airports / cities cannot be same.'
            }
        } else if (from1Code == to1Code || from2Code == to2Code) {
            showToast.validate = true
            showToast.msg = 'Departure and arrival airports / cities cannot be same.'
        }

        if (showToast.validate) {
            toastHandler(showToast.msg, true)
        } else {
            let num_legs = isEmpty(from3Code) ? 2 : 3
            if (
                from1
                    .split(' -')[1]
                    .split(', ')
                    .pop()
                    .trim() !== 'IN' ||
                from2
                    .split(' -')[1]
                    .split(', ')
                    .pop()
                    .trim() !== 'IN' ||
                to1
                    .split(' -')[1]
                    .split(', ')
                    .pop()
                    .trim() !== 'IN' ||
                to2
                    .split(' -')[1]
                    .split(', ')
                    .pop()
                    .trim() !== 'IN'
            ) {
                intl = 'y'
            }
            if (
                num_legs > 2 &&
                (from3
                    .split(' -')[1]
                    .split(', ')
                    .pop()
                    .trim() !== 'IN' ||
                    to3
                        .split(' -')[1]
                        .split(', ')
                        .pop()
                        .trim() !== 'IN')
            ) {
                intl = 'y'
            }
            let query = {
                from1: from1Code,
                from2: from2Code,

                to1: to1Code,
                to2: to2Code,

                depart_date_1,
                depart_date_2,

                adults,
                childs,
                infants,
                intl,
                sd,
                page,
                class: obj.class,
                multicity: true,
                num_legs
            }
            if (num_legs > 2) {
                query = {
                    ...query,
                    from3: from3Code,
                    to3: to3Code,
                    depart_date_3,
                    rnd_one: tripType,
                    airline: query.airline,
                    carrier: query.carrier
                }
            }
            onSearchClick(query)
        }
    }

    function errorHandler(queryObject) {
        let validate = false
        let msg = ''
        if (queryObject.from == queryObject.to) {
            msg = langTranslate('Departure and arrival airports / cities cannot be same.')
            validate = true
        }

        if (!queryObject.from) {
            msg = langTranslate('Enter departure airport / city')
            validate = true
            setCity({
                ...city,
                departureError: true
            })
        }
        if (!queryObject.to) {
            msg = langTranslate('Enter arrival airport / city')
            validate = true
            setCity({
                ...city,
                arrivalError: true
            })
        }
        if (!queryObject.from && !queryObject.to) {
            msg = langTranslate('Enter departure and arrival airports / cities')
            validate = true
            setCity({
                ...city,
                departureError: true,
                arrivalError: true
            })
        }

        return { validate, msg }
    }
    function toastHandler(errorMsg, closeBtn) {
        setToast({
            errorMsg,
            closeBtn
        })
    }

    function pushCleverTap(name) {
        Clevertap.event('Air_UI_Action', {
            action_type: 'Link',
            action_name: name
        })
    }

    const viewContainerToggle = () => {
        if (!isEmpty(loginRedirectUrl) && isShowing) {
            setLoginRedirectUrl('')
        }
        toggle()
    }

    function setActiveFareHandler(fareType) {
        const { isIntl } = city || {}
        setActiveFare(fareType)
        Clevertap.event('Air_UI_Action', {
            action_name: 'ptc_selected',
            action_type: 'button',
            ptc_fare: returnFareName(fareType),
            is_ptc_fare_selected: returnFareName(fareType) === 'Regular fare' ? 'no' : 'yes',
            journey_type_uiaction: tripType === 'O' ? 'one-way' : 'round-trip'
        })
    }

    useEffect(() => {
        if (
            (desktopHomePageBannerNew.enabled &&
                desktopHomePageBannerNew.properties &&
                desktopHomePageBannerNew.properties.url &&
                desktopHomePageBannerNew.properties.redirectUrl === HI_FIVE_URL &&
                DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN') ||
            (countryCode === 'IN' &&
                desktopHeroOffer.enabled &&
                desktopHeroOffer.properties &&
                desktopHeroOffer.properties.redirectUrl === HI_FIVE_URL)
        ) {
            triggerHiFiveClevertap(
                {
                    logged_in: isUserSignedIn() ? 'yes' : 'no',
                    entry_page: 'flights_home',
                    platform: 'Desktop',
                    domain: resolveKeysInObjectsArrays(['location', 'hostname'], window)
                },
                'Hi5_banner_shown'
            )
        }
    }, [])
    function fareFilter(enabled) {
        const fareType = fareList.map(item => {
            if (item.code === 'senior_citizen' || item.code === 'student') {
                item.active = enabled
                if(!enabled)
                    item.toolTipErrorMsg = `You cannot ${item.fare} with infants/child added to the journey`
            }
            else{
                item.active = true
            }
            return item
        })
        return fareType
    }
    useEffect(() => {
        if (query.childs > 0 || query.infants > 0) {
            //let check = fareFilter(false)
            setFareList(fareFilter(false))
        } else {
            setFareList(fareFilter(true))
        }
        if((city.isIntl === 'y' || (isEmpty(city.isIntl) && city.intl === 'y'))){
            setActiveFare('rf')
            let tempfareList = JSON.parse(JSON.stringify(fareList))
            tempfareList.map(fare=>{
                if(!(fare.code === 'rf')){
                    fare.active = false;
                    fare.toolTipErrorMsg = 'Special fares like student, senior citizen and armed forces are applicable only for domestic flights'
                }
            })
            if(activeFare !== 'rf')
                splFareToggle()
            setFareList(tempfareList)
        }
    }, [query.childs, query.infants,city])

    function handleHomePageBannerClick(url, openInNewTab = true) {
        if (url) {
            pushCleverTap('banner_homepage_bbd')
            if (url === HI_FIVE_URL) {
                triggerHiFiveClevertap({
                    logged_in: isUserSignedIn() ? 'yes' : 'no',
                    action_name: 'Hi5_banner_click',
                    Hi5_entry_point: 'flights_home'
                })
                if (isUserSignedIn()) {
                    window.location.href = url + '?src=fh'
                } else {
                    setLoginRedirectUrl(url + '?src=fh')
                    handleIsShowing()
                    return
                }
            }
            if (openInNewTab) {
                window.open(url)
            } else {
                window.location.href = url
            }
        }
    }

    function setGdpr() {
        window && window.localStorage && window.localStorage.setItem('gdpr', true)
        setCookieBanner(false)
    }


    const handleOptionClick = searchQuery => {
        const name = `${searchQuery?.sourceCountry} ${!isEmpty(searchQuery?.return_date) ? '⇄' : ONWARD_DIR_ARROW} ${searchQuery?.destinationCountry
            }`
        dataLayerGA({ clicked_option_name: name, section: 'Flight', flight_type: (city.isIntl || city.intl) === 'y' ? 'International' : 'Domestic' }, 'your_searches_click')
    }

    function getTitleForMeta() {
        var metaTitle = 'Cleartrip: #1 Travel Booking Site, Book Hotels, Flights Online with Great Offers.'
        if (window && window.location && window.location.pathname && window.location.pathname.includes('/flights')) {
            metaTitle = 'Flight bookings, Cheap flights, Lowest Air tickets @Cleartrip'
        }
        return metaTitle
    }

    function getDescriptionForMeta() {
        var metaDescription = 'Flight Booking & Hotel Booking made easy✔️Get amazing deals on International & Domestic Flight Tickets & choose from 5 lac+ Hotels. Get last minute hot deals🗺️'
        if (window && window.location && window.location.pathname && window.location.pathname.includes('/flights')) {
            metaDescription = 'Book flight tickets online with Cleartrip & get the cheapest flights. Get best deals on domestic flight booking & international flight booking with great offers.'
        }
        return metaDescription
    }
    
    const signupToast = () => {
        return (          
                <div className="bg-neutral-800 p-fixed z-20 w-100p b-0 mb-2 b-0 l-0 m-auto mb-2 p-fixed r-0 z-20" style={{width:'312px'}}>
                    <div
                        className="b-20 bg-neutral-800 c-white br-4 elevation-3 l-0 m-auto py-3 p-absolute r-0 fs-2 flex flex-middle">
                              <TickMark className= "ml-4 mr-2"/>
                             Congratulations! You’ve earned ₹200 in
                             <br /> your Cleartrip wallet
                    </div>
                </div>       
        )
    }

    return (
        <>
        <Helmet>
        <title> {getTitleForMeta()} </title>
        <meta name='description'
          content={getDescriptionForMeta()}/>
        </Helmet>

        <div onClick={setGdpr}>
            {
                showComplianceBanner && (
                    <ComplianceBanner setShowBanner={setShowComplianceBanner} />
                )
            }
            <header className="hbs bc-neutral-100 flex flex-middle p-relative bg-white" style={{ height: 72 }}>
                <div className="bg-white p-relative w-100p z-50">
                    <div className="container" style={{ maxWidth: 1264 }}>
                        <Row className="p-relative">
                            <Col>
                                <ErrorBoundary
                                    title="Global Navigation"
                                    onError={(error, errorInfo) => {
                                        console.log('Error Boundary - GlobalNav')
                                        if (typeof newrelic == 'object') {
                                            newrelic.addPageAction('desktop-error', {
                                                result: 'error',
                                                errorStack: error.stack,
                                                component: 'GlobalNav',
                                                errorInfo: errorInfo
                                            })
                                        }
                                    }}
                                >
                                    <GlobalNav
                                        humbgerShow={false}
                                        minHeader={false}
                                        abTest={getAbTest}
                                        maxWidth={1264}
                                    />
                                </ErrorBoundary>
                            </Col>
                        </Row>
                    </div>
                    {/* <Spacer className="pt-3" /> */}
                </div>
            </header>
            {/* {(getAbTest.ctUpgrade === 'c' || isCtUser()) && (
                <div className="p-relative">
                    <CTUpgradeBanner />
                </div>
            )} */}
            <div className="container w-100p flex-1" style={{ maxWidth: 1264 }}>
                <Row>
                    <Col span={4} className="pr-0 mr-48 mr-0--xs">
                        <Spacer className="pt-5" />
                        <Humbger />
                    </Col>
                    <Col span={19} className="h-fc">
                        <Row>
                            <Col span={17}>
                                <div className="bg-white p-32 mt-7">
                                    <h1 className="fs-9 c-neutral-900 fw-600"> {langTranslate('Search flights')}</h1>
                                    <div className="flex flex-middle mt-2" style={{ minHeight: '20px' }}>
                                        {humbgerSale.flights && humbgerSale.flights.enabled && (
                                            <div className='flex flex-middle' style={{ minHeight: '20px' }}>
                                                {humbgerSale.flights.text ? (
                                                    <>
                                                        <span class="dot ml-1"></span>
                                                        <h2 className="ml-3 fs-4 c-neutral-900 fw-500">
                                                            {humbgerSale.flights.text}
                                                        </h2>
                                                    </>
                                                ) : (
                                                    <h2 className="ml-1 fs-4 c-neutral-900 fw-500">
                                                        {humbgerSale.flights.subHeading}
                                                    </h2>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="pb-8"></div>
                                    <div
                                        className="pt-8 pb-10 p-relative px-10 px-4--xs pt-4--xs pb-4--xs home-search-banner"
                                        style={{
                                            background: '#FFFFFF',
                                            border: '1px solid #E6E6E6',
                                            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.04)',
                                            borderRadius: '12px'

                                        }}
                                    >
                                        <>
                                            <div className="flex">
                                                <JourneyDropdown
                                                    journeyType={tripType}
                                                    tripTypeHandler={tripTypeHandler}
                                                />

                                                <TravellerAndClass query={query} setQuery={setQuery} activeFare={activeFare} />
                                            </div>
                                            <SplFareType
                                                activeFare={activeFare}
                                                fareTypeList={fareList}
                                                tripType={tripType}
                                                handleClick={setActiveFareHandler}
                                            />
                                            <SpecialFareModal isShowing={splFareIsShowing} toggle={splFareToggle}/>
                                            <div className={`w-100p mt-6 ${toast.errorMsg ? 'mb-3' : 'mb-8'}`}>
                                                <NewAirportField
                                                    onArrivalChange={changeArrival}
                                                    onDepartureChange={changeDeparture}
                                                    error={{
                                                        arrival: city.arrivalError,
                                                        departure: city.departureError
                                                    }}
                                                    onSelectArrival={selectArrival}
                                                    onSelectDeparture={item => selectDeparture(item, 'departure')}
                                                    arrivalList={airportSearchList.arrival}
                                                    departureList={airportSearchList.departure}
                                                    departure={departure}
                                                    arrival={arrival}
                                                    loading={loading}
                                                    departurePlaceholder={'Where from?'}
                                                    arrivalPlaceholder={'Where to?'}
                                                    city={city}
                                                    setCity={setCity}
                                                    setDeparture={setDeparture}
                                                    setArrival={setArrival}
                                                    setFinalArrival={setFinalArrival}
                                                    setFinalDeparture={setFinalDeparture}
                                                    toast={toast}
                                                />
                                            </div>
                                            <div className="row  p-relative ">
                                                <div
                                                    className="col flex flex-middle w-100p"
                                                    style={{ marginRight: '-4px' }}
                                                >
                                                    <div>
                                                        <CalendarWrapper
                                                            roundTrip={tripType === 'R'}
                                                            onwardJourny={departure}
                                                            returnJourny={arrival}
                                                            departDate={query.depart_date}
                                                            returnDate={query.return_date}
                                                            dateClick={dateClick}
                                                            searchParams={query}
                                                            toCode={city.dCode}
                                                            fromCode={city.sCode}
                                                            getAbTest={getAbTest}
                                                            journeyType={tripType}
                                                            setTripSelect={setTripSelect}
                                                        />
                                                    </div>
                                                    <div
                                                        className="flex flex-around ml-6 bg-primary-500 hover:bg-primary-600 c-white bc-transparent c-pointer w-100p py-2 px-5 h-10 fs-4 fw-600 t-all button bs-solid tp-color td-500 bw-1 br-4 lh-solid box-border home-search-btn ml-2--xs"
                                                        onClick={searchHandler}
                                                        style={{
                                                            height: '52px',
                                                            paddingTop: '12px',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <span
                                                            className="fw-600 fs-4 lh-2 flex flex-middle"
                                                            style={{ marginBottom: '4px' }}
                                                        >
                                                            {langTranslate('Search flights')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div class="flex flex-row flex-middle mt-8">
                                                <div style={{background: '#EFF5FC',borderRadius:'1px solid #3366CC'}} className="flex flex-center flex-column flex-middle pl-3 pr-3 h-8 br-16 mr-2 fs-14">Regular fare</div>
                                                <div style={{background: '#EFF5FC',borderRadius:'1px solid #3366CC'}} className="flex flex-center flex-column flex-middle pl-3 pr-3 h-8 br-16 mr-2 fs-14">Armed forces fare</div>
                                                <div style={{background: '#EFF5FC',borderRadius:'1px solid #3366CC'}} className="flex flex-center flex-column flex-middle pl-3 pr-3 h-8 br-16 mr-2 fs-14">Student fare</div>
                                                <div style={{background: '#EFF5FC',borderRadius:'1px solid #3366CC'}} className="flex flex-center flex-column flex-middle pl-3 pr-3 h-8 br-16 mr-2 fs-14">Senior citizen fare</div>
                                            </div> */}
                                        </>
                                    </div>
                                    {flightsSearchList && flightsSearchList.length > 0 ? (
                                        <>
                                            <div className="flex flex-between mt-12 mb-6">
                                                <div className="fs-7 fw-600 c-neutral-900">
                                                    {langTranslate('Recent searches')}
                                                </div>
                                            </div>
                                            <ul
                                                className="bc-neutral-100 flex ls-reset mt-2 c-pointer"
                                                style={{ gap: 16 }}
                                            >
                                                {flightsSearchList.map(item => (
                                                    <li
                                                        className="ba bc-neutral-100 br-8 listItemHover"
                                                        style={{ width: 224, height: 72 }}
                                                        onClick={() => {
                                                            handleOptionClick(item)
                                                            replaceQueryInUrl(browserHistory, item)
                                                        }}
                                                    >
                                                        <div className="ml-4 mr-4 mt-4 mb-4 p-relative">
                                                            <a href={formSrpUrl(item)} className="td-none fs-4 fw-500">
                                                                {item.sourceCountry && item.destinationCountry && (
                                                                    <p className="fw-600 fs-3">
                                                                        {item.sourceCountry}{' '}
                                                                        {!isEmpty(item.return_date)
                                                                            ? '⇄'
                                                                            : ONWARD_DIR_ARROW}{' '}
                                                                        {item.destinationCountry}
                                                                    </p>
                                                                )}
                                                            </a>
                                                            <RightArr
                                                                className="p-absolute"
                                                                style={{ right: 3, top: '38%' }}
                                                            />
                                                            <p className="c-neutral-400 fs-2 mt-1">
                                                                {isRtl
                                                                    ? `${getFormattedDate(
                                                                        item.depart_date,
                                                                        'ddd, D MMM',
                                                                        'DD/MM/YYYY'
                                                                    )} ${item.return_date
                                                                        ? '- ' +
                                                                        getFormattedDate(
                                                                            item.return_date,
                                                                            'ddd, D MMM',
                                                                            'DD/MM/YYYY'
                                                                        )
                                                                        : ''
                                                                    }`
                                                                    : `${getFormattedDate(
                                                                        item.depart_date,
                                                                        'ddd, D MMM',
                                                                        'DD/MM/YYYY'
                                                                    )} ${item.return_date
                                                                        ? '- ' +
                                                                        getFormattedDate(
                                                                            item.return_date,
                                                                            'ddd, D MMM',
                                                                            'DD/MM/YYYY'
                                                                        )
                                                                        : ''
                                                                    }`}

                                                                    {/* 5 May — 20 May <span className="fLeft">15 May — 20 May </span> */}
                                                                </p>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        ) : (
                                            <PopularSearch />
                                        )}
                                        {isShowFeatureWidget && 
                                            <FeatureWidget
                                                className="mt-5"
                                                title={FeatureWidgetData?.title}
                                                subText={FeatureWidgetData?.subtext}
                                                icon={FeatureWidgetData?.icon}
                                                onActionClick={onClickWidget}
                                                actionLabel="Learn More"
                                                isCrossEnabled={true}
                                                onCrossClick={()=>setShowFeatureWidget(false)}
                                            />
                                        }

                                        {/* 
                            <div className="col flex flex-middle bb_dotted ml-4 mr-4"></div>

                            <div className="row pt-3 pb-4 p-relative px-4">
                                <div className="col-15 flex flex-middle"></div>
                                <div className="col flex flex-middle">
                                    
                                </div>
                            </div> */}
                                </div>
                            </Col>
                            <Col span={7}>
                                <aside className="ml-4 mt-7">
                                    {countryCode === 'IN' && carousalBanner.enabled && (
                                        <CarousalOffer banners={carousalBanner.banners} />
                                    )}
                                    <HomeOffer searchParams={query} />
                                    {/* 
                                {DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' && (
                                    <>
                                        <Spacer className="pt-3" />
                                        <SuperCoinsBanner />
                                    </>
                                )} */}
                                    {/* {DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' &&
                                    unifiedLoginFlow &&
                                    !isEmpty(userProfile) &&
                                    ((isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)) ||
                                        !userProfile.mobileVerified) && (
                                        <>
                                            <Spacer className="pt-1" />
                                            <VerifyMobileBanner userProfile={userProfile} />
                                        </>
                                    )} */}
                                </aside>
                            </Col>
                            {desktopHomePageBanner.enabled &&
                                desktopHomePageBanner.banners &&
                                desktopHomePageBanner.banners.length > 0 && (
                                    <div className="bg-white p-relative w-100p px-2 pt-15">
                                        <div className="container pl-0 pr-0 c-pointer">
                                            {desktopHomePageBanner.banners.map(function (item, i) {
                                                return (
                                                    <div style={{ maxWidth: 1300, margin: '0 auto' }} key={i}>
                                                        <ImageGrid
                                                            images={item}
                                                            handleClick={handleHomePageBannerClick}
                                                            innerMargin={16}
                                                        // outterMargin="0px 16px"
                                                        />
                                                    </div>
                                                )
                                            })}

                                        </div>
                                        {!isEmpty(desktopHomePageBanner?.login_offer_banner) &&
                                            <div className='p-relative'>
                                                <Spacer className="pt-12" />
                                                <a href="https://cleartrip.app.link/4ZfNFjig9vb">
                                                    <div className="p-absolute btn-android"></div>
                                                </a>
                                                <a href="https://cleartrip.app.link/uy7d0Aauhwb">
                                                    <div className="p-absolute btn-ios"></div>
                                                </a>
                                                <div >
                                                <ImageGrid
                                                    images={desktopHomePageBanner?.login_offer_banner}
                                                    innerMargin={16}
                                                    handleClick={handleHomePageBannerClick}
                                                />
                                                </div>
                                            </div>
                                        }
                                       {!isEmpty(fkResponseImages)&&
                                       <div className='mt-12 c-pointer'>
                                        <FkImages
                                          fkResponseImages={fkResponseImages}
                                          isCarousal={false}
                                        />
                                        </div>
                                }
                                    </div>
                                )}
                            

                            {DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' && <TripSuggestor />}
                            <Row>
                                {DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' && (
                                    <Container>
                                        <Spacer className="pt-12" />
                                        <Col>
                                            {flightPage ? (
                                                <>
                                                    <div>
                                                        <h3 className="fs-5 fw-600 c-neutral-900">Why Cleartrip?</h3>
                                                        <p className="pt-4 c-neutral-700 fs-3">
                                                            It is no longer an uphill battle to get the lowest airfare and book tickets online. Cleartrip is all about making travel
                                                            &nbsp;<span className='fs-3 fw-600 c-neutral-900'>easy, affordable</span>&nbsp;
                                                            and <span className='fs-3 fw-600 c-neutral-900'>simple.</span> From <span className='fs-3 fw-600 c-neutral-900'>international</span> flights to <span className='fs-3 fw-600 c-neutral-900'>domestic</span> flights; from early morning flights to late night flights, from cheap flights to luxurious ones. Cleartrip helps you complete your flight booking in just a few clicks. Your online flight booking experience is seamless with our features like:
                                                        </p>
                                                        {ctFlightsFeatures.map((feature) => {
                                                            return (
                                                                <div className='pt-3'>
                                                                    <span className='fs-3 fw-600 c-neutral-900'>{feature.heading}:</span>&nbsp;
                                                                    <span className='c-neutral-700 fs-3'>{feature.value}</span>
                                                                </div>
                                                            )
                                                        })}
                                                        <p className="pt-4 c-neutral-700 fs-3">
                                                            And with our <span className='fs-3 fw-600 c-neutral-900'>round-the-clock customer service,</span> we ensure no queries or concerns regarding your flight tickets are left unresolved.
                                                        </p>
                                                    </div>
                                                    <HomePageFaq data={flightsFaq} />
                                                    <Spacer className="pt-8" />

                                                    <h3 className="fs-5 fw-600 c-neutral-900">What’s more?</h3>
                                                    <p className="pt-4 c-neutral-700 fs-3">
                                                        Flight ticket booking or planning your travel is made simpler with our
                                                        round trip and multicity options. When you hit enter, your search list
                                                        page shows the results for both onward and return in a split screen
                                                        format letting you choose flights in one go for a round trip. The
                                                        multicity search page shows a list of complete itineraries that removes
                                                        the hassle of you calculating time, transfers and layovers letting you
                                                        finish your online flight booking. To ensure you get the best price we
                                                        highlight offers, sales and other promotions on the checkout page. Post
                                                        booking, our portal allows for easy cancellations or amendments without
                                                        having to make calls to the airlines.
                                                    </p>
                                                </>
                                            ) : (
                                                <>
                                                    <div>
                                                        <h3 className="fs-5 fw-600 c-neutral-900">Why book on Cleartrip?</h3>
                                                        <p className="pt-4 c-neutral-700 fs-3">
                                                            On Cleartrip.com, you can turn all your plans into trips. From flight ticket bookings, and booking hotels online to airport, rental and outstation cab booking, with Cleartrip, no travel dream is far enough. Fly to your favourite destinations with the best flight offers across various airline options like IndiGo, Air India, SpiceJet, Go First, AirAsia, Vistara, etc. Make the most of your holiday plans by relaxing, rejuvenating and enjoying amazing leisure experiences at our vast range of hotels. From affordable and budget-friendly hotels to the best 5-star properties, book your stay on Cleartrip with unmissable offers.  Be it for business travel or pleasure, you can now get the best deals on flights and hotels. So, where to?
                                                        </p>
                                                        <div className='pt-4'>
                                                            <div className='fs-3 fw-600 c-neutral-900'>
                                                                Booking flights & hotels online with Cleartrip
                                                            </div>
                                                            <p className="c-neutral-700 fs-3">
                                                                From queries to itineraries, for all things travel, there is Cleartrip. Checking your flight updates and PNR status is easy with our simple, intuitive app and booking site. Booking online hotels gets seamless with a range of choices and the greatest hotel deals.
                                                            </p>
                                                            <p className="c-neutral-700 fs-3 pt-4">
                                                                Here’s why booking flights and hotels with Cleartrip is your Clear Advantage:
                                                            </p>
                                                            {ctFeatures.map((feature) => {
                                                                return (
                                                                    <div className='pt-3'>
                                                                        <span className='fs-3 fw-600 c-neutral-900'>{feature.heading}:</span>&nbsp;
                                                                        <span className='c-neutral-700 fs-3'>{feature.value}</span>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                    <HomePageFaq data={cleartripHomeFaq} />
                                                </>
                                            )}
                                        </Col>
                                    </Container>
                                )}
                            </Row>
                        </Row>
                    </Col>
                </Row>
                {/* {!isEmpty(toast.errorMsg) && (
                    <Container className="p-fixed z-20 w-100p b-0 mb-2">
                        <Row>
                            <Col span={24}>
                                <Toast
                                    message={langTranslate(toast.errorMsg)}
                                    closeBtn={toast.closeBtn}
                                    className="row"
                                    error
                                    onClose={onToastClose}
                                />
                            </Col>
                        </Row>
                    </Container>
                )} */}
                </div>
            {/* <LanguageSelect /> */}
            <Spacer className="pt-9" />
            <ViewContainer
                page={USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE}
                isShowing={isShowing}
                toggle={viewContainerToggle}
                handleIsShowing={handleIsShowing}
                redirectUrl={loginRedirectUrl}
                abLogin={getAbTest?.login_init}
                abInline={getAbTest?.inlineLogin_nudge}
            />
            {
                showLoginSuccess &&
                <div className="p-fixed z-20 w-100p b-0 mb-2 b-0 l-0 m-auto mb-2 p-fixed r-0 z-20" style={{ width: '312px' }}>
                    <Toast
                        closeBtn={false}
                        message="Logged in successfully!"
                        className="b-20 w-40p bg-neutral-800 c-white br-4 elevation-3 l-0 m-auto py-3 p-absolute r-0"
                    />
                </div>
            }
            {
                showSignupSuccess && signupToast()
            }
            {showFeatureWidgetModal &&
                    <FeatureWidgetModal close={closeFeatureModal} modalData={FeatureWidgetData?.modal} />
            }
            <Footer />
            <CookieBanner cookieBanner={cookieBannerFlag} />
        </div>
        </>
    )
}

export default Home
